import {Component} from '@angular/core'
import {BsModalRef} from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './dialog.component.html',
  standalone: false,
})
export class DialogComponent {
  title: string
  message: string
  options: string[]
  answer = ''

  constructor(public bsModalRef: BsModalRef) {}

  respond(answer: string) {
    this.answer = answer

    this.bsModalRef.hide()
  }
}
